import { useState } from "react";
import { IBlobFile, IUser } from "../../../globals/interfaces";
import FileModal from "../../../components/shared/ImportExportRecords/FileModal";
import { Label } from "reactstrap";
import { getFileIcon } from "../../../utils";
import styled from "styled-components";

interface Props {
    attachments: Array<IBlobFile>;
    setAttachments: React.Dispatch<React.SetStateAction<Array<IBlobFile>>>;
    user: IUser;
}

export default function Attachments ({
    attachments,
    setAttachments,
    user
}: Props) {

    const [attachment, setAttachment] = useState<IBlobFile>(undefined);
    const [fileModal, setFileModal] = useState(false);

    const handleViewAttachment = (item: IBlobFile) => {
        setAttachment(item);
        setFileModal(true);
    }

    return (
        <div>
            <h6>Attachments: </h6>
            {
                attachments.map((item) => (
                    <Attachment 
                        key={item.id} 
                        onClick={() => handleViewAttachment(item)}
                    >
                        <Icon className={getFileIcon(item.s_file_name)} />
                        {item.s_file_name}
                    </Attachment>
                ))
            }
            <FileModal 
                user={user}
                modal={fileModal}
                setModal={setFileModal}
                selectedFile={attachment}
                setFiles={setAttachments}
                personal={true}
            />
        </div>  
    );
}

const Attachment = styled.p`
    &:hover {
        cursor: pointer;
    }
`;

const Icon = styled.i`
    margin-right: 5px;
`;